import { call, fork, put, take, select } from 'redux-saga/effects';

// Actions
import * as actionsCreator from './reducer';

// Type
import { ApiResponse } from '../LibrariesProduct/type';

// Helper
import { RootState } from 'store';

type TypeRequest = {
	ok: boolean;
	status: number;
	data: actionsCreator.TypeData[] | [];
}

export const orders = (store: RootState) => store.orders;

// Selector store
function* _select<T>(fn: (state: RootState) => T) {
	const res: T = yield select(fn);
	return res;
}

export function* ordersStart(api: any, action: any) {
	yield fork(getListOrdersWatcher, api, action);
	yield fork(getOrdersByIdWatcher, api, action);
}

/**
 *  Get molecule product watcher Sagas starter
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getListOrdersWatcher(api: any, action: any): Generator<any, void, any> {
	while (true) {
		try {
			const actions = yield take(actionsCreator.getListOrders.type);
			const withProductProperties = actions.payload.withProductProperties;

			const res: ApiResponse<TypeRequest> = yield call(api.request, 'getAllOrders', { withProductProperties });

			if (!res.ok) {
				yield put(actionsCreator.getListOrdersError());
			} else {
				yield put(actionsCreator.getListOrdersSuccess(res.data));
			}
		} catch (e) {
			console.log('CATCH ERROR in getListOrdersWatcher: ', e);
		}
	}
}

/**
 *  Get molecule info by id watcher Sagas starter
 *
 * @param {function} api - api object
 * @param {object} action - action from dispatch
 * @returns
 */
export function* getOrdersByIdWatcher(api: any, action: any): Generator<any, void, any> {
	while (true) {
		try {
			const actions = yield take(actionsCreator.getOrderById.type);

			const state = yield* _select(orders);
			const list = state.data;

			const projectId = actions.payload.projectId;
			const withProductProperties = actions.payload.withProductProperties;

			const res: ApiResponse<any> = yield call(api.request, 'getOrderById', projectId, withProductProperties);
			if (!res.ok) {
				yield put(actionsCreator.getOrderByIdError());
			} else {
				const id = res?.data?.id;
				const data = res?.data;
				const result = list?.map((x: any) => {
					if (x.id === id) {
						return {
							...x,
							...data,
							items: data.items
						};
					}
					return x;
				});
				yield put(actionsCreator.getOrderByIdSuccess(result));
			}
		} catch (e) {
			console.log('CATCH ERROR in getOrdersByIdWatcher: ', e);
		}
	}
}